<template>
  <v-container class="search-div elevation-2 mb-4">
    <div style="position: relative; left: 10000px; top: -70px;">
      <a name="searchfilters" />
    </div>
    <v-row no-gutters>
      <v-col cols="12" class="search-form-title-red">{{ $t('check_in') }}</v-col>
      <v-col cols="12" class="search-form-date-input">
        <v-text-field
          v-model="searchFilters.dateStart"
          class="date-search-field"
          :persistent-placeholder="true"
          :placeholder="$t('saabumise_kuupäev')"
          type="text"
          autocomplete="off"
          name="checkin"
          id="checkin"
          prepend-inner-icon="fa-calendar-alt"
          readonly
          outlined
          dense
          hide-details
          @click="dateStartFocus($event)"
        />
        <div style="display:none;">!{{ searchFilters.dateStart }}</div>
        <CalendarDatePicker
          v-if="showSearchPickerFor === 'dateStart'"
          v-model="searchFilters.dateStart"
          :left="calendarLeftPosition"
          :mobile-padding="16"
          :for-search-form="true"
          fieldName="dateStart"
          @update="updatePickerDate"
        />
      </v-col>
      <v-col cols="12" class="search-form-title-red">{{ $t('check_out') }}</v-col>
      <v-col cols="12" class="search-form-date-input">
        <v-text-field
          v-model="searchFilters.dateEnd"
          :placeholder="$t('lahkumise_kuupäev')"
          :persistent-placeholder="true"
          class="date-search-field"
          autocomplete="off"
          type="text"
          name="checkout"
          id="checkout"
          prepend-inner-icon="fa-calendar-alt"
          readonly
          outlined
          dense
          hide-details
          @click="dateEndFocus($event)"
        />
        <CalendarDatePicker
          v-if="showSearchPickerFor === 'dateEnd'"
          v-model="searchFilters.dateEnd"
          :starting-from="searchFilters.dateStart"
          :left="calendarLeftPosition"
          :mobile-padding="16"
          :for-search-form="true"
          field-name="dateEnd"
          @update="updatePickerDate"
        />
      </v-col>
      <v-col cols="12" class="mt-1">
        {{ $t('asukoht') }}:
        <v-select
          v-model="searchFilters.region"
          :menu-props="{ contentClass: 'region-select' }"
          :items="objectRegionsComputed"
          :persistent-placeholder="true"
          label=""
          placeholder="- Costa del Sol -"
          item-text="regionName"
          item-value="_id"
          dense
          outlined
          hide-details
        />
      </v-col>
      <v-col cols="12" class="mt-1">
        {{ $t('majutuse_tüüp') }}:
      </v-col>
      <v-col cols="12" class="mt-1">
        <v-container
          :class="isMobileView ? 'white pt-3 px-3 pb-3' : 'white pt-3 px-1 pb-3'"
          style="border-radius: 8px;"
        >
          <v-row no-gutters class="pt-0">
            <!-- v-col cols="12" class="mt-1">
              <v-chip
                :small="!isMobileView"
                :dark="searchFilters.type === 'all'"
                :color="searchFilters.type !== 'all' ? 'grey lighten-4' : '#219bc8'"
                :class="isMobileView ? 'mr-1 my-2' : 'ml-2 my-2'"
                block
                style="display: table;"
                @click="searchFilters.type = 'all'"
              >
                {{ $i18n.t('näita_kõik') }}
              </v-chip>
            </v-col -->
            <v-col
              v-for="(objectType, oti) in objectTypes"
              :key="oti"
              :cols="isMobileView ? 6 : 12"
            >
              <div
                :style="objectTypeStyle(objectType)"
                @click="selectObjectType(objectType)"
              >
                <div style="position: absolute; top: 10px; right: 10px;">
                  <v-icon
                    v-if="searchFilters.type.length === 0 || searchFilters.type.includes(objectType._id)"
                    :color="searchFilters.type.includes(objectType._id) ? 'grey lighten-1' : 'grey lighten-2'"
                    small
                  >
                    {{ 'fa-check-circle' }}
                  </v-icon>
                </div>
                <v-icon
                  :color="searchFilters.type.includes(objectType._id) ? '#219bc8' : 'grey lighten-1'"
                  :large="isMobileView"
                  :class="isMobileView ? 'pb-2' : 'pr-2 pb-1'"
                >
                  fa {{ objectType.icon }}
                </v-icon>
                <br v-if="isMobileView">
                {{ objectType.name }}
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <!-- v-col cols="12" class="mt-1">
        {{ $t('majutuse_tüüp') }}:
        <v-select
          v-model="searchFilters.type"
          class=""
          :items="objectTypes"
          :persistent-placeholder="true"
          :placeholder="$t('näita_kõik')"
          label=""
          item-text="name"
          item-value="_id"
          outlined
          dense
          hide-details
        />
      </v-col -->
      <v-col
        cols="12"
        class="pt-2"
      >
        <BookingFormVisitorSelect
          :sidebar="true"
          :search-form="true"
          @addPerson="addPerson"
          @removePerson="removePerson"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="detailedSearch"
      class="mt-2 mx-0 px-0"
      no-gutters
    >
      <hr class="mt-2" />
      <v-col cols="12" class="mt-1">
        <SearchRoomCountSelect
          v-model="searchFilters.bedroomsCount"
          :title="$t('magamistubade_arv')"
          :options="bedroomOptions"
        />
      </v-col>
      <v-col cols="12" class="mt-1">
        <SearchRoomCountSelect
          v-model="searchFilters.bathroomCount"
          :title="$t('vannitubade_arv')"
          :options="bathroomsOptions"
        />
      </v-col>
      <v-col cols="12" class="mt-1">
        <SearchDayPriceSelect
          :title="$t('night_price')"
          :options="bathroomsOptions"
        />
      </v-col>
      <v-col cols="12" class="mt-3">
        <v-container class="white pt-2 px-3 pb-3" style="border-radius: 8px;">
          <v-row no-gutters class="pt-0">
            <v-col
              cols="12"
              class="mt-1"
            >
              <SearchToggleCheckbox
                v-model="searchFilters.parking"
                :label="$t('parking')"
                false-value="all"
                :true-value="1"
              />
            </v-col>
            <v-col cols="12">
              <SearchToggleCheckbox
                v-model="searchFilters.pool"
                :label="$t('bassein')"
                false-value="all"
                :true-value="1"
              />
            </v-col>
            <v-col cols="12">
              <SearchToggleCheckbox
                v-model="searchFilters.terrace"
                :label="$t('terrass')"
                false-value="all"
                :true-value="1"
              />
            </v-col>
            <v-col cols="12">
              <SearchToggleCheckbox
                v-model="searchFilters.aircon"
                :label="$t('konditsioneer')"
                false-value="all"
                :true-value="1"
              />
            </v-col>
            <v-col cols="12">
              <SearchToggleCheckbox
                v-model="searchFilters.pets"
                :label="$t('lemmikloomad')"
                false-value="all"
                :true-value="1"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col cols="12" class="mt-1">
        CSR ID:
        <v-text-field
          v-model="searchFilters.csrId"
          name="costaid"
          label=""
          autocomplete="off"
          color="grey"
          style="border: 1px solid grey;"
          outlined
          hide-details
          dense
          @keyup.enter="searchFormSubmit"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" class="mt-1">
        <v-btn
          class="elevation-1"
          color="#219bc8"
          block
          dark
          @click.prevent="searchFormSubmit"
        >
          <v-icon small class="mr-1">
            fa-search
          </v-icon>
          {{ $t('otsi') }}
        </v-btn>
      </v-col>
      <v-col
        v-if="!detailedSearch"
        cols="12"
        class="mt-2"
        @click="detailedSearch = true"
      >
        <div style="text-align:center;cursor:pointer;font-size:12px;padding:5px 0 0 0;">
          {{ $t('täpsem_otsing') }}<br>
          <img src="/img/filter-open.png" class="filter-parts" style="padding-top:5px;">
        </div>
      </v-col>
      <v-col
        v-if="detailedSearch"
        cols="12"
        class="my-1"
        @click="detailedSearch = false"
      >
        <div style="text-align:center;cursor:pointer;">
          {{ $t('täpsem_otsing') }}<br>
          <img src="/img/filter-close.png" class="filter-parts">
        </div>
      </v-col>
      <v-col
        v-if="searchConditionsChanged"
        cols="12"
        class="search-clear my-0"
        @click="clearSearch()"
      >
        {{ $i18n.t('clear') }}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import sharedMethods from '../../methods/sharedMethods'
import CalendarDatePicker from '../Calendar/CalendarDatePicker'
import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'
import BookingFormVisitorSelect from '@/components/Forms/BookingFormVisitorSelect'
import sharedComputed from '@/methods/sharedComputed'
import SearchRoomCountSelect from '@/components/Forms/SearchRoomCountSelect'
import SearchDayPriceSelect from '@/components/Forms/SearchDayPriceSelect'
import SearchToggleCheckbox from '@/components/Forms/SearchToggleCheckbox'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'SearchForm',

  components: {
    SearchToggleCheckbox,
    SearchDayPriceSelect,
    SearchRoomCountSelect,
    BookingFormVisitorSelect,
    CalendarDatePicker
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,

    bedroomOptions () {
      return [
        { value: 'all', text: '- ' + this.$t('näita_kõik') + ' -' },
        { value: 0, text: this.$t('stuudiokorter') },
        { value: 1, text: '1 ' },
        { value: 2, text: '2 ' },
        { value: 3, text: '3 ' },
        { value: 4, text: '4+ ' },
      ]
    },

    objectRegionsComputed () {
      return [{
        regionName: '- Costa del Sol -',
        id: 'all',
      }, ...this.objectRegions.filter(objectRegion => {
        return !objectRegion.hidden
      })]
    },

    objectTypes () {
      return [
        // {
        //  _id: 'all',
        //  name: this.$t('näita_kõik'),
        // },
        {
          _id: '5bc8706e35e8e07d222a25ac',
          name: this.$t('type_apartment'),
          icon: 'fa-building',
        },
        {
          _id: '5bc8707335e8e07d222a25ad',
          name: this.$t('type_house'),
          icon: 'fa-home',
        },
      ]
    },

    weeklyPriceOptions () {
      return [
        { value: 'all', text: '- ' + this.$t('näita_kõik') + ' -' },
        { value: 1, text: '... - 500 €' },
        { value: 2, text: '500 € - 1000 €' },
        { value: 3, text: '1000 € - ...' },
      ]
    },

    bathroomsOptions () {
      return [
        { value: 'all', text: '- ' + this.$t('näita_kõik') + ' -' },
        // { value: 0, text: this.$t('stuudiokorter') },
        { value: 1, text: '1 ' },
        { value: 2, text: '2 ' },
        { value: 3, text: '3+ ' },
      ]
    },

    maxPeopleOptions () {
      const options = [
        {
          _id: 1,
          name: 1 + ' ' + this.$t('inimene'),
        },
      ]
      for (let i = 1; i < 18; i++) {
        options.push({
          _id: i,
          name: i + ' ' + this.$t('inimest'),
        })
      }
      return options
    },

    searchConditionsChanged () {
      // console.log('searchConditionsChanged')
      // console.log( JSON.stringify(this.searchFilters), JSON.stringify(this.filterDefaultValues), JSON.stringify(this.searchFilters) !== JSON.stringify(this.filterDefaultValues))
      // console.log('this.filterDefaultValues', this.filterDefaultValues)
      // console.log('this.searchFilters', this.searchFilters)
      const filtersWithoutFavoritesSet = JSON.parse(JSON.stringify(this.searchFilters))
      filtersWithoutFavoritesSet.favorites = 0
      return JSON.stringify(filtersWithoutFavoritesSet) !== JSON.stringify(this.filterDefaultValues)
    },

    calendarLeftPosition () {
      return this.mobile ? '-15px' : '-35px'
    }
  },

  methods: {
    ...sharedMethods,

    selectObjectType (objectType) {
      if (this.searchFilters.type.length === 0) {
        this.searchFilters.type = objectType._id
      } else if (this.searchFilters.type.includes(objectType._id)) {
        const tmp = this.searchFilters.type.split(',')
        // Remove
        const index = tmp.indexOf(objectType._id)
        tmp.splice(index, 1)
        this.searchFilters.type = tmp.join(',')
      } else {
        // Add
        this.searchFilters.type = this.searchFilters.type + ',' + objectType._id
      }
    },

    objectTypeStyle (objectType) {
      const style = {
        position: 'relative',
        border: '2px solid #eee',
        // padding: '10px 15px 5px 15px',
        // borderRadius: '10px',
        margin: '5px',
        cursor: 'pointer',
      }
      style.padding = this.isMobileView ? '15px 15px 10px 15px' : '10px 15px 5px 15px'
      style.borderRadius = this.isMobileView ? '15px' : '10px'
      if (this.searchFilters.type.includes(objectType._id)) {
        style.border = '2px solid #219bc8'
      }
      return style
    },

    dateStartFocus (e) {
      // e.srcElement.blur()
      this.showSearchPickerFor = 'dateStart'
    },

    dateEndFocus (e) {
      // e.srcElement.blur()
      this.showSearchPickerFor = 'dateEnd'
    }
  }
}
</script>

<style lang="scss">
.region-select {
  .v-list-item__title {
    font-size: 15px !important;
    font-weight: 400 !important;
  }
}
.search-wide-input-menu {
  margin-left: -12px;
  margin-right: -12px;
  width: 240px;
}
</style>
